
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/submit",
      function () {
        return require("private-next-pages/submit.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/submit"])
      });
    }
  